import { render, staticRenderFns } from "./checkPlanModal.vue?vue&type=template&id=67ff0136&scoped=true"
import script from "./checkPlanModal.vue?vue&type=script&lang=js"
export * from "./checkPlanModal.vue?vue&type=script&lang=js"
import style0 from "./checkPlanModal.vue?vue&type=style&index=0&id=67ff0136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff0136",
  null
  
)

export default component.exports